import { InputNumber } from 'antd';
import {
  DISPLAY_EMPTY,
  MANAGEMENT_SEAL_REQUEST_CONSTANT,
  QUANTITY_MAX,
  QUANTITY_MIN,
  TSealRequestRow,
} from '../constant';
import { SealRequestModalWrapper } from '../ManagementSealRequestStyled';

const { LABEL, DIALOG_QUANTITY_EDIT } = MANAGEMENT_SEAL_REQUEST_CONSTANT;

type TQuantityEditDialogProps = {
  open: boolean;
  row: TSealRequestRow | null;
  newQuantity: number | null;
  quantityError: string;
  onChangeQuantity: (value: number | null) => void;
  onCancel: () => void;
  onSubmit: () => void;
};

function formatStore(row: TSealRequestRow | null): string {
  if (!row || (!row.storeCode && !row.storeName)) {
    return DISPLAY_EMPTY;
  }

  return `${row.storeCode || ''} ${row.storeName || ''}`.trim();
}

// VAMS_PC_008_01 (数量編集ダイアログ) — opened from ✏️ [4.6] on a table row.
export function QuantityEditDialog({
  open,
  row,
  newQuantity,
  quantityError,
  onChangeQuantity,
  onCancel,
  onSubmit,
}: TQuantityEditDialogProps) {
  return (
    <SealRequestModalWrapper
      open={open}
      title={DIALOG_QUANTITY_EDIT.TITLE}
      maskClosable={false}
      onCancel={onCancel}
      cancelText={DIALOG_QUANTITY_EDIT.BTN_CANCEL}
      okText={DIALOG_QUANTITY_EDIT.BTN_SEND}
      onOk={onSubmit}
      width={480}
      destroyOnClose
    >
      <div className="seal-request-dialog_field">
        <span className="seal-request-dialog_label">
          {DIALOG_QUANTITY_EDIT.STORE}
        </span>
        <span className="seal-request-dialog_value">{formatStore(row)}</span>
      </div>

      <div className="seal-request-dialog_field">
        <span className="seal-request-dialog_label">
          {DIALOG_QUANTITY_EDIT.ASSET_NO}
        </span>
        <span className="seal-request-dialog_value">
          {row?.assetNo || DISPLAY_EMPTY}
        </span>
      </div>

      <div className="seal-request-dialog_field">
        <span className="seal-request-dialog_label">
          {DIALOG_QUANTITY_EDIT.ASSET_NAME}
        </span>
        {/* [D4] full text, no truncate — different from bảng chính [4.4] */}
        <span className="seal-request-dialog_value">
          {row?.assetName || DISPLAY_EMPTY}
        </span>
      </div>

      <div className="seal-request-dialog_field">
        <span className="seal-request-dialog_label">
          {DIALOG_QUANTITY_EDIT.CURRENT_QUANTITY}
        </span>
        <span className="seal-request-dialog_value">
          {row?.quantity === null || row?.quantity === undefined
            ? DISPLAY_EMPTY
            : `${row.quantity}${LABEL.UNIT_SHEETS_SUFFIX}`}
        </span>
      </div>

      <div className="seal-request-dialog_field">
        <span className="seal-request-dialog_label" id="new-quantity-label">
          {DIALOG_QUANTITY_EDIT.NEW_QUANTITY}
        </span>
        <InputNumber
          aria-label={DIALOG_QUANTITY_EDIT.NEW_QUANTITY}
          className={quantityError ? 'seal-request-dialog_input--error' : ''}
          min={QUANTITY_MIN}
          max={QUANTITY_MAX}
          value={newQuantity}
          onChange={onChangeQuantity}
          status={quantityError ? 'error' : undefined}
          style={{ width: '100%' }}
          maxLength={3}
        />
        <span className="seal-request-dialog_note">
          {DIALOG_QUANTITY_EDIT.NEW_QUANTITY_NOTE}
        </span>
        {quantityError && (
          <span className="seal-request-dialog_error" role="alert">
            {quantityError}
          </span>
        )}
      </div>
    </SealRequestModalWrapper>
  );
}
